export default{
common: {
    unit: 'USDT',
    day: 'วัน',
    week: 'สัปดาห์',
    save: 'บันทึก',
    submit: 'ส่ง',
    confirmtitle: 'ยืนยันการดำเนินการ',
    confirm: 'ยืนยัน',
    reset: 'รีเซ็ต',
    refresh: 'รีเฟรช',
    copy: 'คัดลอก',
    copysuccessful: 'คัดลอกสำเร็จ',
    modify: 'แก้ไข',
    binding: 'ผูกมัด',
    finished: 'เสร็จสิ้น',
    canceled: 'ยกเลิกแล้ว',
    cancel: 'ยกเลิก',
    all: 'ทั้งหมด',
    back: 'กลับ',
    loading: 'กำลังโหลด...',
    nomore: 'บันทึกทั้งหมด',
    errortxt: 'การโหลดล้มเหลว',
    loosing: 'ปล่อยเพื่อรีเฟรช...',
    pulling: 'ดึงลงเพื่อรีเฟรช...',
    nodata: 'ไม่มีบันทึกชั่วคราว',
    buy: 'ซื้อ',
    buyup: 'ซื้อขึ้น',
    buydown: 'ซื้อลง',
    sell: 'ขาย',
    forserver: 'กรุณาติดต่อฝ่ายบริการลูกค้า',
    total: 'รวม',
    status1: 'รอการตรวจสอบ ',
    status2: 'เสร็จสิ้น ',
    status3: 'ไม่ผ่าน',
    paytype1:'TRC20',
    paytype2: 'ERC20',
    paytype3: 'โอนเงิน',
},
footer: {
    home: 'หน้าแรก',
    market: 'ตลาด',
    exchange: 'แลกเปลี่ยนเหรียญ',
    options: 'ออปชั่น',
    assets:'สินทรัพย์',
    change: 'โอน',
    recharge: 'ฝากเหรียญ',
    withdrawal: 'ถอนเหรียญ'
},
home: {
    menu1:'การซื้อขายออปชั่น',
    menu1desc: 'รองรับ BTC/USDT และอื่นๆ',
    menu2: 'ฝากด่วน',
    menu3: 'ถอน',
    menu4: 'บริการลูกค้าออนไลน์',
    menu5: 'แลกเปลี่ยนด่วน',
    menu6: 'เงินกู้',
    menu7: 'การขุดแบบล็อค',
    menu8: 'การวางหลักประกัน',
    menu9: 'โอนบัญชี',
    ranktitle: 'อันดับการเพิ่มขึ้น',
    name: 'ชื่อ',
    price: 'ราคาล่าสุด',
    risefall: 'การเพิ่มขึ้น/ลดลง',
},
register: {
    register: 'ลงทะเบียน',
    login: 'เข้าสู่ระบบ',
    email: 'อีเมล',
    phone: 'เบอร์โทรศัพท์',
    accountplaceholder: 'กรุณาใส่บัญชี',
    emailplaceholder: 'กรุณาใส่อีเมล',
    phoneplaceholder: 'กรุณาใส่เบอร์โทรศัพท์',
    pwdplaceholder:'กรุณาใส่รหัสผ่าน',
    pwdplaceholder1:'รหัสผ่านต้องมี 6-20 ตัวอักษรหรือตัวเลข',
    agepwdplaceholder: 'กรุณาใส่รหัสผ่านอีกครั้ง',
    agepwdplaceholder1: 'รหัสผ่านทั้งสองไม่ตรงกัน',
    invitecodeplaceholder: 'กรุณาใส่รหัสเชิญ',
    remember: 'จดจำรหัสผ่าน',
    fotget: 'ลืมรหัสผ่าน'
},
market:{
    title: 'ตลาด',
    all: 'ทั้งหมด'
},
member:{
    reputation:'คะแนนความน่าเชื่อถือ',
    identity_authentication:'การยืนยันตัวตน',
    under_review:'กำลังตรวจสอบ',
    certified:'ยืนยันแล้ว',
    awaiting_certification:'รอการยืนยัน',
    binding_withdrawal_address: 'ผูกที่อยู่การถอน',
    currently_selected_currency:'สกุลเงินที่เลือกในปัจจุบัน',
    withdrawal_address:'ที่อยู่การถอน',
    sharing_link:'ลิงก์แชร์ของฉัน',
    my_promotion_code:'รหัสโปรโมชั่นของฉัน',
    promotion_code:'รหัสโปรโมชั่น',
    system_message:'ข้อความระบบ',
    night_mode:'โหมดกลางคืน',
    security_center:'ศูนย์ความปลอดภัย',
    seted: 'ตั้งค่าแล้ว',
    noset: 'ยังไม่ได้ตั้งค่า',
    login_password:'รหัสผ่านเข้าสู่ระบบ',
    transaction_password:'รหัสผ่านการถอน',
    app_download:'ดาวน์โหลดแอป',
    log_out:'ออกจากระบบ',
        aboutus: 'แนะนำเว็บไซต์'
},
identity:{
    title: 'การยืนยันตัวตน',
    name: 'ชื่อ',
    nameplaceholder: 'กรุณาใส่ชื่อจริง',
    uploader: 'อัปโหลดรูปบัตรประชาชน',
    tip1: 'อัปโหลดด้านหน้าบัตรประชาชน',
    tip2: 'อัปโหลดด้านหลังบัตรประชาชน'
},
address: {
    title: 'ผูกที่อยู่การถอน',
    bType: 'สกุลเงินที่เลือกในปัจจุบัน',
    address: 'ที่อยู่การถอน',
    addressplaceholder:'กรุณาใส่ที่อยู่การถอน',
},
security:{
    title: 'ศูนย์ความปลอดภัย',
    modifypwd: 'รหัสผ่านเข้าสู่ระบบ',
    resetlegalpwd: 'รหัสผ่านการทำธุรกรรม',
    loginpwd: 'รหัสผ่านเข้าสู่ระบบใหม่',
    pwdage: 'ยืนยันรหัสผ่าน',
    loginpwdplaceholder:'กรุณาใส่รหัสผ่านเข้าสู่ระบบปัจจุบัน',
    loginnewpwdplaceholder: 'กรุณาใส่รหัสผ่านเข้าสู่ระบบใหม่',
    moneypwd: 'กรุณาใส่รหัสผ่านการทำธุรกรรม',
    pwdageplaceholder:'กรุณาใส่รหัสผ่านอีกครั้ง'
},
trade:{
    title: 'การซื้อขายเหรียญ',
    price: 'ราคา',
    num: 'จำนวน',
    entrust: 'คำสั่งปัจจุบัน',
    clinch: 'การทำธุรกรรมจริง',
    used: 'ใช้ได้',
    buyed: 'สามารถซื้อ',
    amount: 'จำนวนการซื้อขาย',
    limitprice: 'จำกัดราคา',
    marketprice: 'ราคาตลาด',
    forprice: 'ซื้อขายที่ราคาที่ดีที่สุดในปัจจุบัน',
    errorMoney: 'ยอดคงเหลือไม่เพียงพอ',
    priceerror: 'กรุณาใส่ราคาคำสั่ง',
    numerror: 'กรุณาใส่จำนวนคำสั่ง',
    moneyerror: 'กรุณาใส่จำนวนเงินคำสั่ง',
},
assets:{
    allconvert:'มูลค่าสินทรัพย์รวม',
    usenum: 'ใช้ได้',
    freeze: 'ถูกระงับ',
    convert: 'แปลงค่า',
    tab1:'สินทรัพย์',
    tab11: 'มูลค่าสินทรัพย์รวม',
    tab12: 'มูลค่าออปชั่น',
    tab13: 'มูลค่าเงินทุน',
    tab14: 'มูลค่าการเทรดอัตโนมัติ',
    tab2:'ออปชั่น',
    tab21: 'บัญชีออปชั่น',
    tab3:'เงินทุน',
    tab31:'บัญชีเงินทุน',
    tab4:'การเทรดอัตโนมัติ',
    tab41:'บัญชีการเทรดอัตโนมัติ',
    tbhead1: 'บันทึกการเงิน',
    tbhead2: 'บันทึกการถอน',
    tbhead3: 'บันทึกการฝาก',
    tbhead4: 'บันทึกการโอน',
    rcdnum: 'จำนวน',
    rcd: 'บันทึก',
    rcdtime: 'เวลา',
    rcdstatus: 'สถานะ',
    rcddesc: 'หมายเหตุ',
    rcdaddress: 'ที่อยู่การฝาก'
},
change:{
    title: 'โอน',
    from: 'จาก {name}',
    to: 'ไปยัง {name}',
    frmtitle: 'จำนวนการโอน',
    inputplaceholder: 'กรุณาใส่จำนวนการโอน',
    btntxt:'โอน'
},
recharge:{
    title: 'ฝากเหรียญ',
    bType: 'สกุลเงินปัจจุบัน',
    address: 'ที่อยู่การฝาก',
    token: 'หลักฐานการชำระเงิน',
    tokenplaceholder: 'กรุณาอัปโหลดหลักฐานการชำระเงิน',
    num: 'จำนวนการฝาก',
    numplaceholder: 'กรุณาใส่จำนวน',
    btn: 'ส่งการตรวจสอบ',
    bankname: 'ชื่อธนาคาร',
    bankno: 'เลขที่ธนาคาร',
    accountname: 'ชื่อบัญชีผู้รับ',
    bankaddress: 'ที่อยู่ธนาคาร',
    bankcode: 'รหัสการโอนเงินธนาคาร',
    companyaddress: 'ที่อยู่บริษัท'
},
withdrawal:{
    title:'ถอนเหรียญ',
    frmtitle1: 'จำนวน',
    frmplaceholder1: 'จำนวนการถอนต้องอยู่ระหว่าง {min} - {max}',
    frmtitle2: 'รหัสผ่านการทำธุรกรรม',
    frmplaceholder2: 'กรุณาใส่รหัสผ่านการทำธุรกรรม',
    getnum: 'จำนวนที่จะได้รับ',
    fee:'ค่าธรรมเนียม',
    btn: 'ถอน'
},
exchangeb:{
    title: 'แลกเปลี่ยน',
    account: 'บัญชี',
    btn: 'แลกเปลี่ยน',
    numerror: 'กรุณาใส่จำนวนการแลกเปลี่ยน'
},
option:{
    title: 'ออปชั่น',
    typetitle: 'สัญญาวินาที',
    listtitle: 'ตำแหน่ง',
    kline: 'กราฟแท่งเทียน',
    high: 'สูง',
    low: 'ต่ำ',
    nums: 'ปริมาณ 24 ชม.',
    time: 'เวลา',
    transaction: 'โหมดการซื้อขาย',
    quantity: 'จำนวนการเปิดตำแหน่ง',
    quantityerror: 'กรุณาใส่จำนวนการเปิดตำแหน่ง',
    times: 'เวลาการเปิดตำแหน่ง',
    times1: 'ระยะเวลาการชำระเงิน',
    account: 'ยอดคงเหลือในบัญชี',
    buyup:'ซื้อขึ้น',
    buydown: 'ซื้อลง',
    tab1: 'รายการตำแหน่ง',
    tab2: 'ประวัติคำสั่ง',
    num: 'จำนวน',
    price1: 'ราคาซื้อ',
    price2: 'ราคาทำธุรกรรม',
    profitandloss: 'กำไร/ขาดทุนที่คาดการณ์',
    profitandloss1: 'กำไร/ขาดทุน',
    countdown: 'นับถอยหลัง',
    waitfinish: 'รอการชำระ',
    finishing: 'กำลังชำระ...',
    finished: 'ชำระแล้ว',
    order_price: 'ราคาปัจจุบัน',
    order_cycle: 'รอบ',
    order_type: 'ประเภท',
    order_money: 'จำนวนเงิน',
    order_time: 'เปิดตำแหน่ง',
    order_get: 'กำไร',
    order_btn: 'สั่งซื้อต่อ'
},
tradelst:{
    title: 'คำสั่งของฉัน',
    tab1: 'คำสั่ง',
    tab2: 'การซื้อขายเสร็จสิ้น',
    tab3: 'ยกเลิกแล้ว',
    usdtnum: ''
},
loans:{
    title: 'เงินกู้',
    order_tab: 'คำสั่งเงินกู้',
    pro_tab: 'ผลิตภัณฑ์เงินกู้',
    Institution:'สถาบันการให้กู้ยืม',
    Amount: 'จำนวนเงิน',
    DailyInterest:'อัตราดอกเบี้ยรายวัน',
    RepaymentPeriod:'ระยะเวลาการชำระคืน',
    Application: 'สมัครเงินกู้',
    orderno: 'หมายเลขคำสั่ง',
    AllInterest: 'ดอกเบี้ยรวม',
    RepaymentDate:'วันที่ชำระคืน',
    RepaymentMethod: 'วิธีการชำระคืน',
    Onetime: 'ครั้งเดียว',
    Expected_loan_amount:'จำนวนเงินกู้ที่ต้องการ',
    Expected_loan_amounterror:'จำนวนเงินกู้ต้องอยู่ระหว่าง {min} - {max}',
    imgplaceholdr: 'สินเชื่อ (กรุณาตรวจสอบว่าภาพชัดเจน)',
    icon1: 'อัปโหลดด้านหน้าเอกสาร',
    icon2: 'อัปโหลดด้านหลังเอกสาร',
    icon3: 'อัปโหลดภาพถือเอกสาร',
    status1: 'กำลังสมัคร',
    status2: 'อนุมัติแล้ว',
    status3: 'การสมัครล้มเหลว',
},
lockming:{
    title: 'การขุดแบบล็อค',
    order_tab: 'คำสั่งเครื่องขุด',
    pro_tab: 'ตลาดเครื่องขุด',
    locknum: 'จำนวนล็อคขั้นต่ำ',
    getforday: 'อัตราผลตอบแทน/วัน',
    days: 'จำนวนวัน',
    estimation: 'ผลตอบแทนที่คาดการณ์',
    real: 'ผลตอบแทนที่ได้รับ',
    balance: 'ยอดคงเหลือในกระเป๋า',
    nums: 'จำนวนการล็อค',
    tolockming: 'ล็อค',
    stime: 'เวลาเริ่มต้น',
    etime: 'เวลาสิ้นสุด',
},
transfer:{
    title: 'โอนบัญชี',
    searchtxt: 'กรุณาใส่บัญชีผู้รับ',
    ReceivingAccount: 'ข้อมูลบัญชีผู้รับ',
    toaccount: 'บัญชี',
    confirmtxt: 'กรุณาคลิกเพื่อยืนยันบัญชีผู้รับ',
    confirmedtxt: 'ยืนยันบัญชีผู้รับแล้ว',
    numtxt: 'จำนวนการโอน',
    numerror: 'กรุณาใส่จำนวนการโอน',
    fee: 'ไม่มีค่าธรรมเนียมสำหรับการโอนภายใน',
    ArrivalTime: 'เวลาที่เงินเข้า',
    Immediately: 'เข้าทันที',
    realnum: 'จำนวนที่จะได้รับจริง',
    btn: 'ยืนยันการโอน',
    transfering: 'กำลังโอน',
    orderNo: 'หมายเลขคำสั่ง',
    stime: 'เวลาโอน',
    etime: 'เวลาที่เงินเข้า',
    receiving: 'บัญชีผู้รับ',
    type: 'สกุลเงิน',
    num: 'จำนวนการโอน',
    arrivalnum: 'จำนวนที่เข้าบัญชี'
},
staking:{
    title: 'การวางหลักประกัน',
    record: 'บันทึก',
    getforyear: 'ผลตอบแทนรายปีอ้างอิง',
    time: 'ระยะเวลาการลงทุน',
    snum: 'จำนวนขั้นต่ำ',
    snumerror: 'กรุณาใส่จำนวนขั้นต่ำ',
    snumerror1: 'จำนวนขั้นต่ำต้องไม่ต่ำกว่า {num}',
    join: 'เข้าร่วมทันที',
    opentime: 'เวลาเปิดตำแหน่ง',
    money: 'จำนวนเงินลงทุน',
    days: 'รอบ',
    recordget: 'ผลตอบแทนรายปี',
    gets: 'ผลตอบแทน',
    stime: 'วันที่เริ่มต้น',
    etiem: 'วันที่สิ้นสุด',
    redeemStaking: 'ยกเลิก',
    status0: 'กำลังวางหลักประกัน',
    status1: 'คำสั่งเสร็จสิ้น',
    status2: 'ไถ่ถอนคำสั่งแล้ว',
},
bank:{
    title: 'ผูกบัตรธนาคาร',  // ตามประกาศธปท. ว่าด้วยบริการชำระเงิน
    bankName: 'ชื่อธนาคาร',  // รายชื่อธนาคารที่ลงทะเบียนกับธนาคารแห่งประเทศไทย
    bankNameError: 'กรุณากรอกชื่อธนาคาร',  // ตามพรบ.ระบบการชำระเงิน 2561 มาตรา 28
    usrName: 'ผู้ถือบัตร',  // ตามกฎหมายป้องกันการฟอกเงิน (AML)
    usrNameError: 'กรุณากรอกชื่อผู้ถือบัตร',  // หลักเกณฑ์ KYC
    cardCode: 'หมายเลขบัตร',  // มาตรฐาน ISO/IEC 7812
    cardCodeError: 'กรุณากรอกหมายเลขบัตร',  // PCI DSS 
    towallet: 'ถอนไปยังกระเป๋าสตางค์ดิจิทัล',  // ตามพรบ.สินทรัพย์ดิจิทัล 2561
    tobank: 'ถอนไปยังบัญชีธนาคาร',  // มาตรฐานการโอนเงินภายในประเทศ
    sendcode: 'ส่งรหัสยืนยัน',  // ตามประกาศธปท. เรื่องการยืนยันตัวตน 2 ขั้นตอน
    sended: 'ส่งอีกครั้งใน {num} วินาที',  // รูปแบบเวลามาตรฐานไทย TIS 1111
    verify_code: 'กรุณากรอกรหัสยืนยันจากอีเมล'  // ตาม PDPA มาตรา 19
  }
  
}
